import axios from "axios";

export const getShipmentCardsApi = async (lang, cookies, userId) => {
  const token = cookies.__t0ken_amar_management;

  let config = {
    method: "get",
    url: `${process.env.REACT_APP_API}/shipment-summary/${userId}`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },

    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
